export function timeZoneDetector() {
  if ($('#user_time_zone').length) {
    $('#user_time_zone').val(jstz.determine().name())
  }
}
